// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'


import VConsole from 'vconsole';

// 为每个页面指定标题
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


Vue.use(ElementUI)

const __DEV__ = process.env.NODE_ENV === 'development'

const requestService = axios.create({
  // baseURL: __DEV__ ? '/' : 'https://wx.sc-edu.com/'
  baseURL: ' https://app2020.sggenting.cn/'
})

Vue.prototype.$axios= requestService

requestService({
  url: 'https://nei.netease.com/api/apimock-v2/97dbc8335bfe3f68ab154e44b2149721/debug'
}).then(res => {
  if (res.data.debug) {
    new VConsole();
    if (res.data.webviewBug) {
      window.location.href = 'https://liulanmi.com/labs/core.html'
    }
  }
})

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js